import { BrowserFieldDatabase } from '@/shared/db/browser-field-database';

export const fieldDatabase = new BrowserFieldDatabase();
